export default "__VITE_ASSET__7jVM_7zh__"